import React from "react";
import { Modal, Button } from "react-bootstrap";
import { Document, Page } from "react-pdf";

function PaymentDocumentLayout(props) {
  const { pdfDocument, pageNumber, numPages } = props;

  return (
    <div>
      <Modal
        show={true}
        onHide={() => props.handleShow("PaymentDocumentLayout", false)}
        bsSize="large"
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-primary">
            Finpay Account Authorization
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Document
            file={{ data: pdfDocument }}
            onLoadSuccess={props.onLoadSuccess}
            loading="Loading the document. Please wait..."
          >
            <Page pageNumber={pageNumber} />
          </Document>

          <br />

          <p>
            Page {pageNumber} of {numPages}
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="btn btn-default inline-buttons pull-left"
            onClick={props.onDownloadPressed}
          >
            Download
          </Button>
          <Button
            disabled={pageNumber === 1}
            className="btn btn-warning inline-buttons pull-left"
            onClick={() => props.handlePageNumber(-1)}
          >
            Previous Page
          </Button>
          <Button
            disabled={pageNumber === numPages}
            className="btn btn-warning inline-buttons pull-left"
            onClick={() => props.handlePageNumber(1)}
          >
            Next Page
          </Button>
          <Button
            className="btn btn-warning inline-buttons"
            onClick={() => props.handleShow("PaymentDocuments", false)}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default PaymentDocumentLayout;



// WEBPACK FOOTER //
// ./src/home/components/payment-document-layout.js